<template>
  <el-dialog :title="activeName === 'queryMine' ? '处理反馈' : '处理详情'" :visible.sync="show" :before-close="close" center destroy-on-close>
    <el-form ref="form" :rules="rules" :model="info" label-width="22%">
      <el-row>
          <el-col :span="24">
            <el-form-item label="姓名" prop="eventId" v-if="type !== 'new'">
              <el-input disabled placeholder="编号" show-word-limit v-model="info.name" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="电话" prop="eventId" v-if="type !== 'new'">
              <el-input disabled placeholder="编号" show-word-limit v-model="info.mobile" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="意向园区" prop="eventId" v-if="type !== 'new'">
              <el-input disabled placeholder="编号" show-word-limit v-model="info.parkName" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="eventId" v-if="type !== 'new'">
              <el-input  type="textarea" :rows="5" placeholder="请输入处理结果" maxlength="200" disabled
                show-word-limit v-model="info.remark" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="处理人" prop="applyTitle">
              <el-input :disabled="type !== 'new'" placeholder="处理人" show-word-limit v-model="userName" v-if="activeName === 'queryMine'"/>
              <el-input :disabled="type !== 'new'" placeholder="处理人" show-word-limit v-model="info.handleUser" v-else/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="处理结果" prop="feedbackInfo" >
              <el-input  type="textarea" :rows="5" placeholder="请输入处理结果" maxlength="200" :disabled="activeName === 'queryMyAudit'"
                show-word-limit v-model="info.feedbackInfo" />
            </el-form-item>
          </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addEventForm()" v-if="this.activeName === 'queryMine'">提 交</el-button>
      <el-button @click="close">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { compIntentionFeedbackInfo } from '@/api/comprehensive'
export default {
  data() {
    return {
      timeValue: [],
      info: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      rules: {
        feedbackInfo: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      id: '',
      type: '',
      userName: '',
      show: false,
      userInfoList: [],
      activeName: '',
    }
  },
  methods: {
    // 强制更新测试文本信息框的值
    changeMessage() {
      this.$forceUpdate()
    },
    getDetails(row, type) {
      this.info = { ...row }
      this.activeName = type
      this.show = true
      this.userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName || ''
    },
    close() {
      this.info = {}
      this.show = false
    },
    addEventForm() {
      this.$refs.form.validate(async (vaild) => {
        if (vaild) {
          const { id, feedbackInfo } = this.info
            let params = {
              feedbackInfo: feedbackInfo,
              id: id
            }
            const { code, message } = await compIntentionFeedbackInfo('submitHandleFeedBack', params)
          if (code !== 0) {
            this.$message.error(message)
            return
          }
          this.$message.success('提交成功！')
          this.$emit('addSuccess')
          this.close()
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  min-width: 540px;
  width: 50%;
}
</style>
